const DEFAULT_PAGE = "offer-search-page";
const ROUTES_TO_PAGES = {
    "/login": "login-page",
    "/register": "register-page",
    "/offer": "offer-page",
    "/offer/chat": "offer-chat-page",
    "/offer/new": "offer-create-page",
    "/offer/edit": "offer-edit-page",
    "/user": "user-page",
    "/user/edit": "user-edit-page",
};
export default class Router {
    static initialize() {
        const path = window.location.pathname + window.location.search;
        history.replaceState(null, "", path);
        Router.renderCurrentPage();
        window.onpopstate = () => Router.onPopState();
        window.onclick = (event) => Router.onClick(event);
    }
    static renderCurrentPage() {
        const path = window.location.pathname;
        const page = document.createElement(ROUTES_TO_PAGES[path] || DEFAULT_PAGE);
        document.body.innerHTML = "";
        document.body.appendChild(page);
    }
    static onPopState() { Router.renderCurrentPage(); }
    // Interception des liens dans les balises <a>
    static onClick(event) {
        const target = event.target;
        const anchor = target.closest("a");
        if (anchor === null)
            return;
        const href = anchor.getAttribute("href");
        if (href && href.startsWith("/")) {
            event.preventDefault();
            history.pushState(null, "", href);
            Router.renderCurrentPage();
        }
    }
}
